export default __webpack_public_path__ + "static/media/unlocked.0e72f0d9.svg";